import React from "react";

export default function ItemsSelectedWindow({
  visible,
  items = [],
  onRemoveItem,
  onFinish,
  onClose,
}) {
  if (!visible) return null;

  return (
    <div
      style={{
        width: 370,
        maxHeight: "min(86vh, 920px)",
        borderRadius: 22,
        background: "linear-gradient(160deg, rgba(8, 30, 58, 0.98) 0%, rgba(3, 14, 36, 0.99) 100%)",
        border: "1px solid rgba(80, 180, 255, 0.38)",
        boxShadow: "0 0 40px rgba(0, 150, 255, 0.18), 0 8px 28px rgba(0, 0, 0, 0.72)",
        color: "#e0f7fa",
        pointerEvents: "auto",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          padding: "18px 18px 10px",
          borderBottom: "1px solid rgba(144, 224, 239, 0.12)",
        }}
      >
        <div style={{ fontWeight: 800, color: "#40e8ff", fontSize: 20 }}>
          Selected ({items.length})
        </div>
        <button type="button" className="names-btn secondary" onClick={onClose}>
          Close
        </button>
      </div>

      <div
        style={{
          padding: "12px 18px",
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          scrollbarWidth: "thin",
          scrollbarColor: "rgba(64, 200, 255, 0.82) rgba(2, 10, 26, 0.92)",
          scrollbarGutter: "stable",
          display: "grid",
          gap: 8,
        }}
      >
        {items.length === 0 ? (
          <div style={{ color: "rgba(224,247,250,0.78)", fontSize: 13 }}>
            No items selected yet.
          </div>
        ) : (
          items.map((entry) => (
            <div
              key={`basket-${entry.item.id}`}
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr) auto",
                alignItems: "center",
                gap: 10,
                borderRadius: 10,
                padding: "8px 10px",
                background: "rgba(4, 18, 38, 0.75)",
                border: "1px solid rgba(80,180,255,0.22)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                {entry.item?.icon ? (
                  <img src={entry.item.icon} alt="" style={{ width: 20, height: 20, objectFit: "contain" }} />
                ) : null}
                <span
                  style={{ color: "#d9f6ff", fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }}
                  title={entry.item?.name || "Unknown item"}
                >
                  {entry.item?.name || "Unknown item"} x{entry.quantity}
                </span>
              </div>
              <button
                type="button"
                className="names-btn secondary"
                onClick={() => onRemoveItem?.(entry.item.id)}
              >
                Remove
              </button>
            </div>
          ))
        )}
      </div>

      <div style={{ padding: "10px 18px 18px", borderTop: "1px solid rgba(144,224,239,0.12)", display: "flex", justifyContent: "flex-end" }}>
        <button
          type="button"
          className="names-btn primary"
          onClick={onFinish}
          disabled={!items.length}
        >
          Finish
        </button>
      </div>
    </div>
  );
}
